import { render, staticRenderFns } from "./WeightIndicator.vue?vue&type=template&id=059e866d&scoped=true&"
import script from "./WeightIndicator.vue?vue&type=script&lang=js&"
export * from "./WeightIndicator.vue?vue&type=script&lang=js&"
import style0 from "./WeightIndicator.vue?vue&type=style&index=0&id=059e866d&prod&scoped=true&lang=css&"
import style1 from "./WeightIndicator.vue?vue&type=style&index=1&id=059e866d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059e866d",
  null
  
)

export default component.exports